
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 5h18c1.093 0 2 .907 2 2v18c0 1.093-.907 2-2 2H7c-1.093 0-2-.907-2-2V7c0-1.093.907-2 2-2zm0 2v18h9.688v-6.75h-2.625v-3h2.625V13c0-2.583 1.571-3.969 3.875-3.969 1.104 0 2.067.057 2.344.094v2.719h-1.625c-1.253 0-1.469.595-1.469 1.469v1.938h2.969l-.375 3h-2.594v6.75h5.188v-18h-18z"}})])
          )
        }
      }
    